// a react-three-fiber scene
import { softShadows } from "@react-three/drei";

import React, { useMemo, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import Model from "./Next_plant_v3_final";
import Plane from "./Plane_lemon3";
import { Suspense } from "react";
import { Floor } from "./Scene";
import {
  EffectComposer,

  Vignette,
  Bloom,
} from "@react-three/postprocessing";
// import { animated, useSpring } from "@react-spring/three";
// import { useControls } from "leva";
import * as T from "three";

softShadows();

export default function Scene8() {
  return (
    <div style={{ height: "100%" }}>
      <Suspense falllback={null}>
        <Canvas
          shadows
          orthographic
          camera={{ position: [-25, 25, -25], zoom: 70, fov: 35 }}
        >
          <fog attach="fog" args={["#ddd", 50, 180]} />

          <Suspense falllback={null}>
            <Inner />
            <Floor color={"#777"}></Floor>
            <ambientLight intensity={2}></ambientLight>
          </Suspense>
          <EffectComposer>
            <Bloom luminanceThreshold={0} luminanceSmoothing={2} height={300} />
            <Vignette eskil={false} offset={0.1} darkness={0.8} />
          </EffectComposer>
        </Canvas>
      </Suspense>
    </div>
  );
}

function Inner() {
  // let { camera } = useThree();
  /*const { zoom } = useControls({
    zoom: {
      value: 80,
      onChange: (v) => {
        camera.zoom = v;
        camera.updateProjectionMatrix();
      },
    },
  });*/
  return (
    <>
      <Model position={[0, 0, 0]} scale={1}></Model>
      <Airplane></Airplane>
      <Airplane></Airplane>
      <Airplane></Airplane>
      <Airplane></Airplane>
    </>
  );
}

function Airplane() {
  let plane = useRef();
  let target = useRef();
  const data = useMemo(() => ({
    position: new T.Vector2(Math.random() * 20 - 10, Math.random() * 20 - 10),
    rotation: Math.random() * 10 - 5,
    speed: Math.random() * 4 + 2,
    timeRandom: Math.random() * 3 + 1,
    hoverPoint: new T.Vector3(),
  }), []);
  useFrame(({ mouse, clock, viewport }, delta) => {
    const x = (mouse.x * viewport.width) / 2;
    const y = (mouse.y * viewport.height) / 2;

    const targetPosition = new T.Vector2(-x, y).rotateAround(
      new T.Vector2(0, 0),
      -Math.PI / 4
    );
    if (target.current) {
      target.current.position.x = targetPosition.x;
      target.current.position.z = targetPosition.y;
    }
    if (plane.current) {
      let pos = data.position;
      let rotation = data.rotation;

      let moveVec = new T.Vector2(0, -1).rotateAround(
        new T.Vector2(0, 0),
        rotation
      );

      let angle = new T.Vector3(moveVec.x, moveVec.y, 0).angleTo(
        new T.Vector3(0, 0, 0).copy(
          targetPosition.clone().sub(pos).x,
          targetPosition.clone().sub(pos).y,
          0
        )
      );
      console.log(angle);
      if (angle > 0.2) {
        rotation += 0.03;
      }
      if (angle < 0.2) {
        rotation -= 0.03;
      }
      pos.add(moveVec.multiplyScalar(delta * data.speed));
      console.log(angle);
      plane.current.position.x = pos.x;
      plane.current.position.z = pos.y;
      plane.current.rotation.y = rotation;
      data.pos = pos;
      data.rotation = rotation;
    }
  });
  return (
    <group>
      <mesh ref={target}>
        <boxBufferGeometry args={[1, 1, 1]}></boxBufferGeometry>
        <meshNormalMaterial></meshNormalMaterial>
      </mesh>
      <group
        ref={plane}
        position={[data.position.x, 4, data.position.y]}
        rotation={[0, -data.rotation, 0]}
      >
        <Plane></Plane>
      </group>
    </group>
  );
}
